module.exports = __webpack_public_path__ + "static/img/defaultImage.6519a9a5.png";